module.exports = "<div class=\"well text-center\">\n    <h3>Error</h3>\n    <a class=\"btn btn-primary\" ng-click=\"errorCtrl.refresh()\">Reload</a>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/error/template.html
// module id = 1259
// module chunks = 0